/**
 * @ngdoc controller
 * @name AccountsController
 * @description
 * This component renders the Accounts section.
 *
 * @memberof account
 */
class AccountsController {
  /**
   * Class constructor.
   * @param {Service} $location    To redirect the user when he selects an account.
   * @param {Object}  $rootScope   To broadcast the authorization events.
   * @param {Service} ccaSession   To get the list of accounts.
   * @param {Object}  AUTH_EVENTS  To get the name of the event to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    ccaSession,
    AUTH_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
    /**
     * The local reference to the `accounts` array.
     * @type {Array}
     */
    this.accounts = ccaSession.getAccounts();
    /**
     * The local reference to the `user` object.
     * @type {Object}
     */
    this.user = ccaSession.getUser();
  }
  /**
   * Broadcast the customerSelected event with the selected account and redirect to home.
   * @param  {Object} account the account to set as active.
   */
  selectAccount(account) {
    this.$rootScope.$broadcast(this.AUTH_EVENTS.customerSelected, account);
    this.$location.url('/');
  }
}

export default AccountsController;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/accounts/accounts.controller.js